import {PipelineContainer} from './components/pipeline-container';

export default {
    component: PipelineContainer
};
